import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-professor-category',
    templateUrl: './professor-category.component.html',
    styleUrls: ['./professor-category.component.scss']
})
export class ProfessorCategoryComponent implements OnInit {

    @Input() category: any;
    readableCategoryNameUpperCase: string;
    categoryClass: string;

    constructor(
    ) {

    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['category']) {
            this.category = changes['category'].currentValue;
        }
    }

    async ngOnInit() {
        this.readableCategoryNameUpperCase = this.category.readableName.toUpperCase();
        this.initCategoryClass()
    }

    initCategoryClass() {
        let categoryClass;
        switch (this.category.name) {
            case 'SUPER':
                categoryClass = 'super-category';
                break;
            case 'TOP':
                categoryClass = 'top-category';
                break;
            case 'STAR':
                categoryClass = 'star-category';
                break;
            default:
                categoryClass = 'default-category';
                break
        }
        this.categoryClass = categoryClass;
    }

}
